import { supabase } from '@/integrations/supabase/client';

const SESSION_KEY = 'mci-session-id';

export function getSessionId(): string {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'anon';
  }
}

export type GameEventType = 'game_started' | 'game_completed';

export interface GameEventPayload {
  event_type: GameEventType;
  kaiju_id?: string | null;
  algorithm?: 'START' | 'SALT' | null;
  score?: number | null;
}

export function logGameEvent(payload: GameEventPayload): void {
  // Fire-and-forget; never throw / never block gameplay
  try {
    supabase
      .from('game_events')
      .insert({
        event_type: payload.event_type,
        kaiju_id: payload.kaiju_id ?? null,
        algorithm: payload.algorithm ?? null,
        score: payload.score ?? null,
        session_id: getSessionId(),
      })
      .then(({ error }) => {
        if (error) console.warn('[analytics] logGameEvent failed:', error.message);
      });
  } catch (e) {
    console.warn('[analytics] logGameEvent threw:', e);
  }
}
